import fetch from "@lib/fetch";
import { getPermissionValue } from "@lib/permissionConstants";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { GetTeamsProps, TeamsPermissionPayload } from "./types";

/**
 * This is a replacement for `refreshAllowedTerritoriesByAppGroupIdByPermission` in the `DeveloperViewModel`.
 *
 * @example
 * const appGroupId = useAppGroupId();
 * const { data: teamsByAppGroupbyPermission } = useDashboardApiQuery("/app_settings/allowed_territories_for_developer_for_company", {
 *   params: [
 *     {
 *       permissionNames: ["sendCampaigns"],
 *       appGroupIds: [appGroupId],
 *       ignoreFilters: true,
 *     }
 *   ],
 * });
 */
export const getTeamsPermissions = reactQueryFetcherAdapter(
  cacheKey,
  async (
    signal,
    { permissionNames, appGroupIds, ignoreFilters }: GetTeamsProps
  ): Promise<TeamsPermissionPayload> => {
    return fetch(
      cacheKey,
      "GET",
      {
        permission_names: permissionNames.map(getPermissionValue),
        only_these_app_group_ids: appGroupIds,
        ignore_filters: ignoreFilters,
      },
      { signal }
    );
  }
);
